import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const LogoutIcon = ({ color, className }: IconProps) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12.6182" r="11.375" stroke={color ?? 'current-color'} strokeWidth="1.25" />
      <path
        d="M6.55806 12.1762C6.31398 12.4203 6.31398 12.816 6.55806 13.0601L10.5355 17.0376C10.7796 17.2817 11.1753 17.2817 11.4194 17.0376C11.6635 16.7935 11.6635 16.3978 11.4194 16.1537L7.88388 12.6182L11.4194 9.08263C11.6635 8.83855 11.6635 8.44282 11.4194 8.19875C11.1753 7.95467 10.7796 7.95467 10.5355 8.19875L6.55806 12.1762ZM18 13.2432C18.3452 13.2432 18.625 12.9633 18.625 12.6182C18.625 12.273 18.3452 11.9932 18 11.9932V13.2432ZM7 13.2432H18V11.9932H7V13.2432Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LogoutIcon;
